
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 46 46","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M23.5 1C11.073 1 1 11.074 1 23.498 1 35.926 11.073 46 23.5 46S46 35.926 46 23.498C46 11.074 35.927 1 23.5 1z","fill":"#4FA2B7"}}),_c('path',{attrs:{"d":"M23.5 35C29.85 35 35 29.85 35 23.499 35 17.147 29.85 12 23.5 12S12 17.147 12 23.499C12 29.85 17.15 35 23.5 35","stroke":"#FFF","stroke-width":".4"}}),_c('path',{attrs:{"d":"M28.097 18.903a6.504 6.504 0 010 9.194 6.504 6.504 0 01-9.194 0 6.504 6.504 0 010-9.194 6.504 6.504 0 019.194 0","fill":"#FFF"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/oltFill.svg